/* eslint-disable */
import React from 'react';
import getUrlExtension from '@src/utils/get-url-extension';
import { withoutProps } from '@src/utils/data-utils';
import extendAppend from '@src/components/modal/__helper__/extend-append';
import styles from './index.less';
import Link from '@src/components/link';
import cx from 'classnames';

// 空函数
const noop = () => {};

// 检测是否为iOS设备
const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

// 检测是否为QQ浏览器
const isQQBrowser = () => {
  return /QQBrowser/i.test(navigator.userAgent);
};

// 检测是否为iOS QQ浏览器
const isIOSQQBrowser = () => {
  return isIOS() && isQQBrowser();
};

@extendAppend({ modalClassName: styles.modal })
export default class Video extends React.PureComponent {
  /**
   * 是否是 m3u8
   * @returns {boolean}
   */
  isM3u8() {
    const { src } = this.props;
    const { m3u8 = src.search('.m3u8') > 0 } = this.props;
    // console.log('m3u8?', m3u8);
    return m3u8;
  }

  getSpreadProps() {
    return withoutProps(this.props, ['generalPlayerIframeUrl', 'm3u8PlayerIframeUrl', 'src', 'modal', 'isModalCloseVisible']);
  }

  /**
   * 渲染除了 m3u8 以外的视频
   * @returns {*}
   */
  renderGeneralPlayer() {
    const { src, modal, onCloseCallback = noop } = this.props;
    return this.renderVideo({
      src: src,
      onClose: onCloseCallback,
      modal
    });
  }

  /**
   * 渲染 m3u8 视频
   * @returns {*}
   */
  renderM3u8PlayerIframeUrl() {
    const { src, modal, onCloseCallback = noop } = this.props;
    return this.renderVideo({
      src: src,
      onClose: onCloseCallback,
      modal
    });
  }

  renderVideo(props) {
    const { modal, src, wrapIframeClassName, onClose } = props;

    return (
      <React.Fragment>
        <video
          className={cx(isIOS() && isQQBrowser() ? wrapIframeClassName : styles.video)}
          autoPlay
          controls
          controlsList='nodownload'
          preload='auto'
          x-webkit-airplay='true'
          airplay='allow'
          webkit-playsinline='true'
          playsInline={true}
          // {...this.getSpreadProps()}
        >
          <source src={src} type='video/mp4' />
        </video>
        {modal && (
          <Link
            className={styles.close}
            onClick={() => {
              modal.onClose();
              onClose();
            }}
          />
        )}
      </React.Fragment>
    );
  }

  render() {
    return this.isM3u8() ? this.renderM3u8PlayerIframeUrl() : this.renderGeneralPlayer();
  }
}

Video.defaultProps = {
  generalPlayerIframeUrl: '//zhcdn01.xoyo.com/xassets/iframe/video/0.0.x/index.html',
  m3u8PlayerIframeUrl: '//zhcdn01.xoyo.com/xassets/iframe/m3u8-media-play/0.0.x/index.html',
  width: '100%',
  height: '100%',
  frameBorder: 0,
  allowFullScreen: true
};
